import { init as initApm } from "@elastic/apm-rum";

const isApmEnabled = process.env.REACT_APP_ENABLE_APM !== "false";

var apm = initApm({
  active: false,
  environment: process.env.REACT_APP_ENVIRONMENT,
  serviceName: "patient booking app",
  serverUrl:
    "https://122719dc36f24758add942f7fbad072c.apm.us-east-1.aws.cloud.es.io/",
  serviceVersion: process.env.REACT_APP_VERSION,
  distributedTracingOrigins: [process.env.REACT_APP_FHIR_ENDPOINT],
});

export default apm;
